import { ProductType } from '@/types';

export const getDefaultValues = ({ defaultValues }: ProductType) => defaultValues;
